// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"p8-z","upvote":"q8-z","downvote":"r8-z","numVotes":"s8-z","votesDescription":"t8-z","report":"u8-z","voted":"v8-z","answerVoteBox":"w8-z","justReported":"x8-z"};